"use client";

import styles from "./styles.module.css";
import ImageContainer from "@components/atoms/ImageContainer";

export default function Animation4Gear({ style, section }: { style?: string, section: any }) {
  return (
    <div className={`${style || ""}`}>
      {[4, 5, 6, 4].map((item, index) => {
        return (
          <ImageContainer
            key={index}
            image={`/gear${item}.webp`}
            containerStyle={styles[`container__gear${index + 4}`]}
            imageStyle={styles["container__gear-image"]}
            alt={section[item].alt}
            title={section[item].title}
            fill
            sizes="(max-width: 640px) 50vw, (max-width: 768px) 30vw, 300px"
          />
        );
      })}
    </div>
  );
}
